export function toHumanDate(date) {
  return date
    .split("-")
    .reverse()
    .join("/");
}

export function dayDiff(dateString) {
  var today = new Date();
  var date = new Date(dateString);

  // To calculate the time difference of two dates
  var differenceInTime = date.getTime() - today.getTime();

  // To calculate the no. of days between two dates
  return Math.floor(differenceInTime / (1000 * 3600 * 24));
}

export const emojis = [
  "😁",
  "😂",
  "😃",
  "😄",
  "😅",
  "😆",
  "😉",
  "😊",
  "😋",
  "😌",
  "😍",
  "😏",
  "😒",
  "😓",
  "😔",
  "😖",
  "😘",
  "😚",
  "😜",
  "😝",
  "😞",
  "😠",
  "😢",
  "😤",
  "😥",
  "😨",
  "😩",
  "😪",
  "😫",
  "😭",
  "😰",
  "😱",
  "😲",
  "😳",
  "😵",
  "😷",
  "😸",
  "😹",
  "😺",
  "😻",
  "😼",
  "😽",
  "😾",
  "😿",
  "🙀",
  "🙅",
  "🙆",
  "🙇",
  "🙈",
  "🙉",
  "🙊",
  "🙋",
  "🙌",
  "🙍",
  "🙎",
  "🙏"
];

export const formFields = (fields, initial = {}) => {
  const form = {};
  const errors = {};
  for (const i in fields) {
    const field = fields[i];
    form[field] = initial && initial[field] ? initial[field] : "";
    errors[field] = [];
  }
  return { form, errors, loading: false };
};

export const youtubeParser = url => {
  var regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|shorts\/|live\/|watch\?v=)([^#\&\?]*).*/;
  var match = url.match(regExp);
  return match && match[1].length == 11 ? match[1] : false;
};

export const vimeoParser = url => {
  var firstPart = url.split("?")[0].split("/");
  return firstPart[firstPart.length - 1];
};

export const daysBetweenDates = (firstDate, secondDate) => {
  const oneDay = 24 * 60 * 60 * 1000;
  return Math.ceil((firstDate - secondDate) / oneDay);
};

export const timeFromNow = date => {
  const removeTimeZone = d =>
    d && d[d.length - 1] == "Z" ? `${d}`.slice(0, d.length - 1) : d;

  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const olderDate = new Date(removeTimeZone(date));
  const currentDate = new Date();

  const diff = ((olderDate - currentDate) / _MS_PER_DAY) * -1;

  const formatter = new Intl.RelativeTimeFormat("pt-BR", {
    hourCycle: "h24",
    numeric: "auto",
    timeStyle: "short",
    style: "short",
    timeZone: "America/Sao_Paulo"
  });

  switch (true) {
    case diff > 7:
      return formatter.format(-Math.floor(diff / 7), "week");
    case diff > 1:
      return formatter.format(-Math.round(diff), "days");
    case diff > 0.04:
      return formatter.format(-Math.round(diff * 24), "hour");
    default:
      return formatter.format(-Math.round(diff * 24 * 60), "minutes");
  }
};

export const calculateTimeFromNow = date => {
  if (!date) return null;

  const removeTimeZone = d =>
    d[d.length - 1] == "Z" ? `${d}`.slice(0, d.length - 1) : d;

  const _MS_PER_DAY = 1000 * 60 * 60 * 24;
  const olderDate = new Date(removeTimeZone(date));
  const currentDate = new Date();

  const diff = ((olderDate - currentDate) / _MS_PER_DAY) * -1;

  return diff;
};

export const phoneMask = value => {
  if (!value) return "";
  value = value.replace(/\D/g, "");
  value = value.replace(/(\d{2})(\d)/, "($1) $2");
  value = value.replace(/(\d)(\d{4})$/, "$1-$2");
  return value;
};

export const removeMask = maskedValue => {
  return maskedValue
    .replace(/\s/g, "")
    .replace(/-/g, "")
    .replace(/\(/g, "")
    .replace(/\)/g, "")
    .replace(/\D/g, "")
    .trim();
};

export const prepareWppNumber = value => {
  if (value.slice(0, 2) == "55") {
    return value;
  }

  return "55" + value;
};

export const clearObject = object => {
  for (const i in object) {
    if (object[i] === "" || object[i] === undefined || object[i] === null) {
      delete object[i];
    }
  }
  return object;
};

export const seconds_to_time = time => {
  return Math.floor(time / 3600);
};

export const duration_seconds_to_humanized = duration => {
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;
  let ret = "";
  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
};
export const humanized_minutes = value => {
  const duration = value * 60;
  const hrs = ~~(duration / 3600);
  const mins = ~~((duration % 3600) / 60);
  const secs = ~~duration % 60;
  let ret = "";
  ret += "" + (hrs > 0 ? hrs + "h" : "") + (mins < 10 ? "0" : "");
  ret += "" + mins + "min";
  return ret;
};

export const diff_from_now = started_at => {
  const removeTimeZone = d =>
    d[d.length - 1] == "Z" ? `${d}`.slice(0, d.length - 1) : d;

  const diff =
    new Date().getTime() - new Date(removeTimeZone(started_at)).getTime();
  return Math.ceil(diff / 1000);
};

export const diff_in_days = (start, end) => {
  const date1 = new Date(start);
  const date2 = new Date(end);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays;
};

export const removeTimeZone = d =>
  d[d.length - 1] == "Z" ? `${d}`.slice(0, d.length - 1) : d;
